var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 32,
    cy: 32,
    r: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#EB7C7C",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#10B483",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.8 43.117V22.483c.053-.626.399-1.18.92-1.472a1.629 1.629 0 0 1 1.654.03L43.32 31.487c.427.322.681.847.681 1.405 0 .56-.254 1.083-.68 1.406l-15.946 10.26c-.51.311-1.134.323-1.655.031-.52-.291-.866-.846-.919-1.472z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleLearning);
export default __webpack_public_path__ + "static/media/simple_learning.4c012779cafd96495a4efcdb90362a07.svg";
export { ForwardRef as ReactComponent };